module.exports = __webpack_public_path__ + "static/media/(V)_MG_6199_-_Joias_Contenporaneas.23f021e9.jpg";